import React from 'react';
import { ProductItemProps } from '../types';
import { handleTrack } from '../../../utils/tracker';
import { If } from '../../Atoms/Conditionals';

const ProductItem: React.FC<ProductItemProps> = ({ product, onHover }) => {
  const handleProductClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    handleTrack({
      label: 'inpage_cta',
      obj: event.target,
    });
  };

  return (
    <a
      data-label={product.label}
      onClick={handleProductClick}
      href={product.link}
      className="block"
      onMouseEnter={() => onHover?.(product.id)}
      onMouseLeave={() => onHover?.(null)}
    >
      <div className="flex p-2 cursor-pointer rounded-lg hover:bg-blue-50 transition-colors h-24">
        <div className="w-1/4 sm:w-1/5">
          <img
            src={product.icon}
            width="44"
            height="44"
            alt={product.id}
            loading="lazy"
            className="w-11 h-11"
          />
        </div>
        <div className="w-3/4 sm:w-4/5">
          <h6 className="font-bold text-font-500 mb-1 flex items-start">
            {product.title}
            <If condition={!!product.badge}>
              <span className="bg-purple-300 h-5 rounded-md text-white items-center flex text-sm font-normal ml-2 px-2">
                {product.badge}
              </span>
            </If>
          </h6>
          <p className="text-font-200 text-sm">{product.description}</p>
        </div>
      </div>
    </a>
  );
};

export default ProductItem;
